/* eslint-disable max-len */
import {
  SEARCH_RATE_LIMIT_GET_CONFIG_URL,
  SEARCH_RATE_LIMIT_GET_VIOLATIONS_URL,
  SEARCH_RATE_LIMIT_UPDATE_CONFIG_URL,
} from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { GetSearchRateLimitConfigRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/search_rate_limit/request/GetSearchRateLimitConfigRequest';
import { GetSearchRateLimitViolationsRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/search_rate_limit/request/GetSearchRateLimitViolationsRequest';
import { UpdateSearchRateLimitConfigRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/search_rate_limit/request/UpdateSearchRateLimitConfigRequest';
import {
  BACKOFFICE_GET_SEARCH_RATE_LIMIT_CONFIG_RESPONSE,
  BACKOFFICE_GET_SEARCH_RATE_LIMIT_VIOLATIONS_RESPONSE,
  BACKOFFICE_UPDATE_SEARCH_RATE_LIMIT_CONFIG_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

RequestResponseMappingManager.addMapping(
  SEARCH_RATE_LIMIT_GET_CONFIG_URL,
  BACKOFFICE_GET_SEARCH_RATE_LIMIT_CONFIG_RESPONSE,
);
RequestResponseMappingManager.addMapping(
  SEARCH_RATE_LIMIT_UPDATE_CONFIG_URL,
  BACKOFFICE_UPDATE_SEARCH_RATE_LIMIT_CONFIG_RESPONSE,
);
RequestResponseMappingManager.addMapping(
  SEARCH_RATE_LIMIT_GET_VIOLATIONS_URL,
  BACKOFFICE_GET_SEARCH_RATE_LIMIT_VIOLATIONS_RESPONSE,
);

export function sendGetSearchRateLimitConfig(payload: GetSearchRateLimitConfigRequest): WebSocketAction {
  return wsSendAction(SEARCH_RATE_LIMIT_GET_CONFIG_URL, payload);
}

export function sendUpdateSearchRateLimitConfig(payload: UpdateSearchRateLimitConfigRequest): WebSocketAction {
  return wsSendAction(SEARCH_RATE_LIMIT_UPDATE_CONFIG_URL, payload);
}

export function sendGetSearchRateLimitViolations(payload: GetSearchRateLimitViolationsRequest): WebSocketAction {
  return wsSendAction(SEARCH_RATE_LIMIT_GET_VIOLATIONS_URL, payload);
}
